export default __webpack_public_path__ + "static/media/reg.89785095.jpg";